export default __webpack_public_path__ + "static/media/logo-desktop-nav-2b2a29.b96db2d6.svg";